import { Container } from "@/components/Container";
import { Stack, Typography } from "@mui/material";

import { DoubtProps } from "./types";
import { AccordionCustom } from "@/components/AccordionCustom";

export const Doubt: React.FC<DoubtProps> = ({ doubtList, title, description }) => {
  return (
    <Container my={6} py={3} id="perguntas-frequentes">
      <Stack spacing={{ xs: 2, sm: 4, md: 4 }} direction="column">
        <Stack spacing={1}>
          <Typography
            fontWeight={600}
            alignSelf={{ xs: "start", sm: "center", md: "center" }}
            fontSize={{ xs: 24, sm: 40, md: 40 }}
            lineHeight={{ xs: "28.8px", sm: "48.01px", md: "48.01px" }}
          >
            {title}
          </Typography>

          <Typography
            fontSize={{ xs: 16, sm: 18, md: 18 }}
            textAlign={{ xs: "start", sm: "center", md: "center" }}
            alignSelf={{ xs: "start", sm: "center", md: "center" }}
            color="#58595B"
          >
            {description}
          </Typography>
        </Stack>

        <Stack spacing={1}>
          {doubtList?.map((item, index) => (
            <AccordionCustom key={index} {...item} />
          ))}
        </Stack>
      </Stack>
    </Container>
  );
};
